<template>
    <div class="main">
        <table-top-head></table-top-head>
        <div class="single-page-con">
            <div class="single-page">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive" />
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive" />
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import tableTopHead from "../../../components/tableTopHead.vue";
    import breadcrumbNav from "../../../components/breadcrumbNav.vue";

    export default {
        name: "table-main",
        data() {
            return {};
        },
        computed: {
            currentPath() {
                return this.$store.getters.currentPath; // 当前面包屑数组
            }
        },
        components: {
            tableTopHead,
            breadcrumbNav
        },
        methods: {}
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/detailPage";
</style>
<style lang="scss">
    .nav-main .ivu-breadcrumb-item-separator {
        margin: unset;
    }

    .ivu-page-item-active {
        border-color: #00b49c;
        background: #00caaf;
    }

    .ivu-page-item:hover {
        border-color: #00caaf;
    }

    .ivu-page-item-active a {
        color: #fff;
    }

    .ivu-page-item-active:hover a {
        color: #fff !important;
    }

    .ivu-page-item:hover a {
        color: #00caaf;
    }

    .ivu-page-next:hover, .ivu-page-prev:hover {
        border-color: #00caaf;
    }

    .ivu-page-next:hover a, .ivu-page-prev:hover a {
        color: #00caaf;
    }

    a {
        color: #00caaf;
    }

    a:hover {
        color: #00caaf;
    }
</style>
